import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X, CaretDown, ArrowUpRight } from "@phosphor-icons/react";
import { NAV } from "../data/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation();

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-ez-bg/90 backdrop-blur-md border-b border-ez-text"
    >
      <div className="max-w-[1600px] mx-auto flex items-center justify-between px-5 md:px-8 h-16 md:h-[72px]">
        <Link to="/" data-testid="nav-logo" className="flex items-center group">
          <img src="/eazymuv-logo.jpeg" alt="Eazymuv" className="h-8 md:h-9 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((item) =>
            item.children ? (
              <div
                key={item.label}
                className="relative"
                onMouseEnter={() => setOpenMenu(item.label)}
                onMouseLeave={() => setOpenMenu(null)}
              >
                <button
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className="flex items-center gap-1 px-4 py-2 text-sm font-medium hover:text-ez-text/60 transition-colors"
                >
                  {item.label}
                  <CaretDown size={12} weight="bold" />
                </button>
                {openMenu === item.label && (
                  <div className="absolute top-full left-0 w-72 bg-ez-bg border border-ez-text">
                    {item.children.map((c) => (
                      <Link
                        key={c.to}
                        to={c.to}
                        data-testid={`nav-sub-${c.to.replace("/", "")}`}
                        className="flex flex-col gap-0.5 px-4 py-3 border-b border-ez-border last:border-b-0 hover:bg-ez-yellow transition-colors"
                      >
                        <span className="text-sm font-semibold">{c.label}</span>
                        <span className="text-xs text-ez-text/60">{c.desc}</span>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`px-4 py-2 text-sm font-medium transition-colors ${
                  location.pathname === item.to ? "text-ez-text" : "hover:text-ez-text/60"
                }`}
              >
                {item.label}
              </Link>
            )
          )}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="nav-cta"
            className="hidden sm:inline-flex items-center gap-1.5 bg-ez-text text-ez-bg px-5 py-2.5 text-sm font-semibold hover:bg-ez-yellow hover:text-ez-text transition-colors"
          >
            Discuss Your Operations
            <ArrowUpRight size={16} weight="bold" />
          </Link>
          <button
            className="lg:hidden p-2"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-ez-bg border-t border-ez-text max-h-[80vh] overflow-y-auto" data-testid="mobile-menu">
          {NAV.map((item) =>
            item.children ? (
              <div key={item.label} className="border-b border-ez-border">
                <div className="px-5 py-3 text-xs uppercase tracking-widest text-ez-text/50 font-mono-ez">
                  {item.label}
                </div>
                {item.children.map((c) => (
                  <Link
                    key={c.to}
                    to={c.to}
                    onClick={() => setOpen(false)}
                    className="block px-8 py-3 text-sm font-medium border-t border-ez-border"
                  >
                    {c.label}
                  </Link>
                ))}
              </div>
            ) : (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="block px-5 py-4 text-base font-semibold border-b border-ez-border"
              >
                {item.label}
              </Link>
            )
          )}
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            className="block px-5 py-4 bg-ez-text text-ez-bg font-semibold text-center"
          >
            Discuss Your Operations
          </Link>
        </div>
      )}
    </header>
  );
}
